import { FilenameConventionEvBased } from 'src/app/models/filename-conventions/filename-convention-payload';
import { EvConventionEditorPayload } from './ev-convention-editor/ev-convention-editor.component';

export const evEditorPayloadToConvention = (
  payload: EvConventionEditorPayload,
): FilenameConventionEvBased | null => {
  const msEv = payload.conventionMsEv;
  if (msEv == null) return null;
  return {
    mode: 'evBased',
    template: payload.template,
    entries: [
      {
        masterSuiteId: msEv.masterSuiteId,
        masterSuiteEnhancementVariantId: msEv.masterSuiteEnhancementVariantId,
        selects: payload.perSelectRows,
      },
    ],
  };
};
